import { render, staticRenderFns } from "./Anmeldeformular.vue?vue&type=template&id=acc0ebf0&scoped=true&"
import script from "./Anmeldeformular.vue?vue&type=script&lang=js&"
export * from "./Anmeldeformular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc0ebf0",
  null
  
)

export default component.exports